export default __webpack_public_path__ + "static/media/tent.32a9bc58.webm";